<script lang="ts" setup>
import { ButtonBack as LumeeButtonBack } from '@brighterly/lib-lumee-ui'

import { useButtonBack } from '@composables/widgets/orders/checkout/button-back.hook'

defineOptions({
  name: 'ButtonBack',
})

const {
  show,
  setSubmit,
} = useButtonBack()
</script>

<template>
  <span
    v-if="show"
    class="button-back"
  >
    <LumeeButtonBack
      view="default"
      aria-label="Back"
      @click="setSubmit"
    />
  </span>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Orders/Checkout/ButtonBack.scss" />
